import { Immutable } from "immer";
import React from "react";

import { templates } from "@reactivated";

import { DistanceToStore } from "../DistanceToStore";

type IProps = Immutable<templates.DistanceToStoreTemplate>;

export const DistanceToStoreSSR = (_props: IProps): React.JSX.Element => {
    return (
        <span className="finance-use__cta al-financing-page__three-ways--distance-to-store">
            <DistanceToStore />
        </span>
    );
};
